<span
	on:mouseover="fire('hoverstart', identifier)"
	on:mouseleave="fire('hoverend', identifier)"
>
	{{yield}}
</span>
